//#!if readonly !== true
// import _ from "lodash";
// 
// import sortOptions from "../constants/sortOptions";
// import tableDropAction from "../constants/tableDropAction";
// import { batchActions } from "./chainReducer";
// import { isDateValid } from "./definition/calendar/dateFunctions";
// import { itemOperations } from "./items";
// import { narrativeOperations, narrativeSelectors } from "./narrative";
// import { positionToKeyPath } from "./narrative/utils";
// import { sequenceOperations } from "./sequence";
// 
// Inputs:
// - state
// - dragItemIds = all items being dragged
// - dropTarget = the item that was dropped on
// - dropAction - Above, Below, or On...
// - sortOrder = sorted by narrative or date/sequence?
// const getActionForTableDrop = (state, dragItemIds, dropTargetId, dropAction, sortOrder) => {
// if (sortOrder === sortOptions.NARRATIVE) {
// return getActionForNarrativeOutlineDrop(state, dragItemIds, dropTargetId, dropAction);
// } else if (sortOrder === sortOptions.SEQUENCE) {
// return getActionForSpreadsheetDrop(state, dragItemIds, dropTargetId, dropAction);
// }
// };
// 
// 1. Ensure dragItemIds are sorted
// 2. Find super and sequence index for drop location
// 3. For each dragged item...
//   a. If the item has a date already, work out what date it should change to...
//      i/ If dragging down, make it the same date as the item below the drop position?
//      ii/ If dragging up, make it the same date as the item above the drop position?
//
//      Note: dropping "above" index 2 should be treated exactly the same as
//            dropping "below" index 1... as visually the user won't be able to distinguish
//            which is occurring as they drag and drop.
//
//   b. Set the sequence index so that they don't get out of order (incrementing as we go).
//   c. Set the super of the parent.
//
// Questions:
//   Do all dragged items get the same date?
//   Prefer to preserve relative dates between them, but this may not be possible if trying to
//   keep everything within the drawn lines.
//
// TODO: At a future date, consider whether we want to do anything better than this, and try to preserve
// relative offsets from each other etc. if we can...
// 
// const getDropDateChange = (sequence, dropIndex, id, obj, dragItemIds, itemsById, superId) => {
  // Find where this item started in the sequence
// const startIndex = sequence.indexOf(id);
// const draggingDown = startIndex < dropIndex;
// const minIndex = draggingDown ? startIndex + 1 : dropIndex;
// const maxIndex = draggingDown ? dropIndex : startIndex;
  // And now find all items it has been dragged past to get to the drop location.
// const bypassedIds = sequence.slice(minIndex, maxIndex).filter(id => _.indexOf(dragItemIds, id) === -1);
// 
// if (draggingDown) {
    // If dragging down, then we need to set the start date of this item to the latest date we passed
    // (unless the current date is later)
// const latestDate = bypassedIds.reduce((output, pId) => {
// const pObj = itemsById.get(pId);
// if (pObj && pObj.super === superId && pObj.startDate && !_.isNil(pObj.startDate.timestamp)) {
// if (!output) {
// return pObj.startDate;
// }
// return pObj.startDate.timestamp > output.timestamp ? pObj.startDate : output;
// }
// return output;
// }, null);
// 
    // If that date is later than the current date, set it to that date
// if (latestDate && latestDate.timestamp > obj.startDate.timestamp) {
// return latestDate;
// }
// } else {
    // If dragging up, then we need to set the start date of this item to the earliest date we passed
    // (unless the current date is earlier)
// const earliestDate = bypassedIds.reduce((output, pId) => {
// const pObj = itemsById.get(pId);
// if (pObj && pObj.super === superId && pObj.startDate && !_.isNil(pObj.startDate.timestamp)) {
// if (!output) {
// return pObj.startDate;
// }
// return pObj.startDate.timestamp < output.timestamp ? pObj.startDate : output;
// }
// return output;
// }, null);
    // If that date is later than the current date, set it to that date
// if (earliestDate && earliestDate.timestamp < obj.startDate.timestamp) {
// return earliestDate;
// }
// }
// };
// 
// const getActionForSequenceDrop = (state, dragItemIds, dropTargetId, dropIndex, setSuper) => {
// const sequence = state.data.sequence;
// const itemsById = state.data.items.byId;
// 
// const targetObj = itemsById.get(dropTargetId);
// const superId = targetObj ? targetObj.super : null;
// 
// const sortedDragIds = sequence.filter(id => dragItemIds.indexOf(id) >= 0);
// 
  // First, create action to set sequence number and super for all items
// let actions = [sequenceOperations.moveItemsInSequence(dragItemIds, dropIndex)];
// if (setSuper) {
// actions.push(itemOperations.setSuper(dragItemIds, superId));
// }
// 
// sortedDragIds.forEach(id => {
    // First, work out if this item has a date.
// const obj = itemsById.get(id);
// 
    // If the item does not have a start date, then we don't need to adjust anything
    // for this item.
// if (!obj || !obj.startDate || _.isNil(obj.startDate.timestamp)) {
// return;
// }
// 
// const newDate = getDropDateChange(sequence, dropIndex, id, obj, dragItemIds, itemsById, superId);
// if (isDateValid(newDate)) {
// actions.push(itemOperations.setPreferredStartDate([id], newDate.timestamp, newDate.precision));
// }
// });
// 
  // Finally, return a single action that batches them all together
// return batchActions(actions);
// };
// 
// const getActionForSpreadsheetDrop = (state, dragItemIds, dropTargetId, dropAction) => {
  // If we dropped on the row, then we just need to set super and be done with it.
// if (dropAction === tableDropAction.DropOnRow) {
// return itemOperations.setSuper(dragItemIds, dropTargetId);
// }
// if (dropAction === tableDropAction.DropTopLevel) {
// return itemOperations.setSuper(dragItemIds, null);
// }
// const sequence = state.data.sequence;
// const targetIndex = sequence.indexOf(dropTargetId);
// const dropIndex = dropAction === tableDropAction.DropAboveRow ? targetIndex : targetIndex + 1;
// return getActionForSequenceDrop(state, dragItemIds, dropTargetId, dropIndex, true);
// };
// 
// const getActionForNarrativeOutlineDrop = (state, dragItemIds, dropTargetId, dropAction) => {
// const narrativeTree = narrativeSelectors.getNarrativeTree(state);
// const targetPosition = narrativeSelectors.getNarrativePositionForItem(narrativeTree, dropTargetId).toArray();
// 
// let parent = null;
// let index = null;
// 
// if (dropAction === tableDropAction.DropOnRow) {
    // If we are dropping directly onto the row, then the parent is the row we drop on,
    // and we place it at the end
// const targetKeyPath = positionToKeyPath(targetPosition);
// const targetTree = narrativeTree.getIn(targetKeyPath);
// const numChildren = targetTree.children.size;
// parent = dropTargetId;
// index = numChildren;
// } else {
    // Otherwise, we are placing it inside the parent of this target row
// const parentPosition = targetPosition.slice(0, -1);
// const parentKeyPath = positionToKeyPath(parentPosition);
// const parentTree = narrativeTree.getIn(parentKeyPath);
// parent = parentTree.id;
// index =
// targetPosition.length > 0 ? _.last(targetPosition) + (dropAction === tableDropAction.DropAboveRow ? -1 : 0) : 0;
// }
// return narrativeOperations.moveInNarrative(dragItemIds, parent, index);
// };
// 
//#!endif

let dropSelectors = null;
//#!if readonly !== true
// dropSelectors = {
// getActionForTableDrop,
// getActionForSequenceDrop,
// getActionForSpreadsheetDrop,
// getActionForNarrativeOutlineDrop,
// getDropDateChange
// };
//#!else
dropSelectors = {
  getActionForTableDrop: () => {},
  getActionForSequenceDrop: () => {},
  getActionForSpreadsheetDrop: () => {},
  getActionForNarrativeOutlineDrop: () => {},
  getDropDateChange: () => {}
};
//#!endif

export default dropSelectors;
